<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >format_list_numbered</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom >{{'main.level' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" style="display: none">
          <input id="search1" autocomplete="off" matInput #filter2 placeholder="{{'main.search' | translate}}">
        </mat-form-field>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>
      <!-- / SEARCH -->

      <button mat-raised-button
        (click)="newLevel()"
        class="add-product-button mat-white-bg my-12 mt-sm-0">
        <span>{{'level.new' | translate}}</span>
      </button>

    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">

      <mat-table class="products-table"
        #table [dataSource]="levels"
        matSort
        [@animateStagger]="{value:'50'}"
        fusePerfectScrollbar>


        <!-- Name Column -->
        <ng-container cdkColumnDef="level">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'level.level' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let level">
            <p class="text-truncate">{{level.level}}</p>
          </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container cdkColumnDef="status">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'level.status' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let level">
            <p class="text-truncate">{{level.status}}</p>
          </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container cdkColumnDef="sort">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'level.sort' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let level">
            <p class="text-truncate">{{level.sort}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="badge">
          <mat-header-cell *cdkHeaderCellDef></mat-header-cell>
          <mat-cell *cdkCellDef="let level">
            @if (level.badge) {
<img class="product-image" style="background: gray;     outline-style: solid;
    outline-color: gray;
    outline-width: thick;"
                [alt]="level.badge"
                [src]="getImage(level.badge)"/>
            }
            @if (!level.badge) {
              <img class="product-image" [src]="'assets/images/badge.svg'">
            }
          </mat-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

        <mat-row *cdkRowDef="let level; columns: displayedColumns;"
          class="product"
          matRipple
          (click)="editLevel(level)">
        </mat-row>

      </mat-table>
      @if (levels.filteredData.length === 0) {
        <div class="no-data-msg">
          <span class="mat-headline-6">{{'main.noData' | translate}}</span>
        </div>
      }
      <mat-paginator #paginator
        [length]="levels.filteredData.length"
        [pageIndex]="0"
        [pageSize]="50"
        [pageSizeOptions]="[25, 50, 100]">
      </mat-paginator>

    </div>
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>
